import React from "react";
import TimeAgo from "react-timeago";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import { cleanDate } from "../../../../util/app";

function VitalList({ items = [], onView }) {
    if (!items.length)
        return (
            <div className="text-center">
                <h4 className="text-pink">No Vital has been recorded yet!</h4>
            </div>
        );
    return (
        <div className="inbox-body">
            <div className="inbox-body no-pad table-responsive">
                <table className="table table-inbox table-hover table-bordered">
                    <thead>
                        <tr>
                            <th className="text-center" scope="col">
                                SN
                            </th>
                            <th scope="col">Date & Time</th>
                            <th scope="col">Score</th>
                            <th scope="col">Staff</th>
                            <th scope="col">Initial</th>
                            <th className="text-center">View</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item, index) => (
                            <tr key={index}>
                                <td className="inbox-small-cells text-center">{index + 1}</td>

                                <td className="view-message">
                                    <strong>{cleanDate(item.created_at)}</strong>{" "}
                                    <span className="badge badge-primary">
                                        {Intl.DateTimeFormat("en-GB", {
                                            hour12: true,
                                            minute: "numeric",
                                            hour: "numeric",
                                            second: "numeric"
                                        }).format(new Date(item.created_at))}
                                    </span>
                                    <p className="text-muted">
                                        <TimeAgo date={item.created_at} />
                                    </p>
                                </td>

                                <td className="view-message">
                                    <strong>{item.score}</strong>
                                </td>
                                <td className="view-message">
                                    <StaffProfileCard item={item.author} />
                                </td>
                                <td className="view-message">{item.initial || "Initial not set!"}</td>
                                <td className="view-message text-center">
                                    <button type="button" onClick={() => onView(item)} title="View" className="mdl-button mdl-button--icon mdl-button--colored btn-default">
                                        <i className="material-icons text-primary">list</i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default VitalList;
